/**
 * Phonics Letter Aa — 课程数据配置
 *
 * 媒体资源基础路径（对应服务器 /media/phonics/aa/）
 * 开发环境通过 public/media/phonics/aa/ 访问，生产环境由 NGINX 提供
 *
 * 统一数据结构：
 * {
 *   layout: '...',
 *   videos: [{ src, poster? }],
 *   lines: [{ en, cn?, audioEn, audioCn? }],
 *   splitAt?: number,   // video-left-vocab-right: 前 N 条 = 右侧单词，剩余 = 视频下方句子
 *                       // dual-videos: 前 N 条 = 左视频台词，剩余 = 右视频台词
 * }
 */

const MEDIA_BASE = '/media/phonics/aa';
const V = 'v1';

export const letterData = {
  letter: 'A',
  title: 'Phonics',
  subtitle: 'Letter A',

  mediaBase: MEDIA_BASE,

  // Step 1: 歌曲视频片段
  songVideo: {
    src: `${MEDIA_BASE}/Aa.mp4?${V}`,
    startTime: 11,
    endTime: 77,
  },

  // Step 2: 4 格单词视频
  wordVideos: [
    { id: 1, src: `${MEDIA_BASE}/video_s3_word1.mp4?${V}`, cover: `${MEDIA_BASE}/image7.png?${V}` },
    { id: 2, src: `${MEDIA_BASE}/video_s3_word2.mp4?${V}`, cover: `${MEDIA_BASE}/image8.png?${V}` },
    { id: 3, src: `${MEDIA_BASE}/video_s3_word3.mp4?${V}`, cover: `${MEDIA_BASE}/image9.png?${V}` },
    { id: 4, src: `${MEDIA_BASE}/video_s3_word4.mp4?${V}`, cover: `${MEDIA_BASE}/image10.png?${V}` },
  ],

  // 统一 storySections
  // layout 类型：
  //   video-left-vocab-right  — 左视频 + 句子 / 右单词
  //   video-top-lines-bottom  — 视频在上，台词在下
  //   dual-videos            — 双视频并排
  storySections: [
    // Step 3: Learn the words (1) — has / an / ax + has an ax
    // splitAt=3: 前3条=单词(右侧)，剩余=句子(视频下方)
    {
      label: 'Learn the words (1)',
      layout: 'video-left-vocab-right',
      videos: [{ src: `${MEDIA_BASE}/video_words1_has_an.mp4?${V}`, poster: `${MEDIA_BASE}/image11.png?${V}` }],
      splitAt: 3,
      lines: [
        { en: 'has', cn: '有', audioEn: `${MEDIA_BASE}/w_en_has.mp3?${V}`, audioCn: `${MEDIA_BASE}/w_cn_has.mp3?${V}` },
        { en: 'an', cn: '一个/一把', audioEn: `${MEDIA_BASE}/w_en_an.mp3?${V}`, audioCn: `${MEDIA_BASE}/w_cn_an.mp3?${V}` },
        { en: 'ax', cn: '斧子', audioEn: `${MEDIA_BASE}/w_en_ax.mp3?${V}`, audioCn: `${MEDIA_BASE}/w_cn_ax.mp3?${V}` },
        { en: 'has an ax', cn: '有一把斧子', audioEn: `${MEDIA_BASE}/s_en_has_an_ax.mp3?${V}`, audioCn: `${MEDIA_BASE}/s_cn_has_an_ax.mp3?${V}` },
      ],
    },

    // Step 4: Learn the words (2) — is / this / your + 4句
    {
      label: 'Learn the words (2)',
      layout: 'video-left-vocab-right',
      videos: [{ src: `${MEDIA_BASE}/video_words2_your.mp4?${V}`, poster: `${MEDIA_BASE}/image13.png?${V}` }],
      splitAt: 3,
      lines: [
        { en: 'is', cn: '是', audioEn: `${MEDIA_BASE}/w_en_is.mp3?${V}`, audioCn: `${MEDIA_BASE}/w_cn_is.mp3?${V}` },
        { en: 'this', cn: '这个', audioEn: `${MEDIA_BASE}/w_en_this.mp3?${V}`, audioCn: `${MEDIA_BASE}/w_cn_this.mp3?${V}` },
        { en: 'your', cn: '你的', audioEn: `${MEDIA_BASE}/w_en_your.mp3?${V}`, audioCn: `${MEDIA_BASE}/w_cn_your.mp3?${V}` },
        { en: 'This is an ax.', cn: '这是一把斧子。', audioEn: `${MEDIA_BASE}/s_en_this_is_an_ax.mp3?${V}`, audioCn: `${MEDIA_BASE}/s_cn_this_is_an_ax.mp3?${V}` },
        { en: 'Is this an ax?', cn: '这是一把斧子吗？', audioEn: `${MEDIA_BASE}/s_en_is_this_an_ax.mp3?${V}`, audioCn: `${MEDIA_BASE}/s_cn_is_this_an_ax.mp3?${V}` },
        { en: 'This is your ax.', cn: '这是你的斧子。', audioEn: `${MEDIA_BASE}/s_en_this_is_your_ax.mp3?${V}`, audioCn: `${MEDIA_BASE}/s_cn_this_is_your_ax.mp3?${V}` },
        { en: 'Is this your ax?', cn: '这是你的斧子吗？', audioEn: `${MEDIA_BASE}/s_en_is_this_your_ax.mp3?${V}`, audioCn: `${MEDIA_BASE}/s_cn_is_this_your_ax.mp3?${V}` },
      ],
    },

    // Step 5: Learn the words (3) — yes / it / my + 2句
    {
      label: 'Learn the words (3)',
      layout: 'video-left-vocab-right',
      videos: [{ src: `${MEDIA_BASE}/video_words3_my.mp4?${V}`, poster: `${MEDIA_BASE}/image14.png?${V}` }],
      splitAt: 3,
      lines: [
        { en: 'yes', cn: '是的', audioEn: `${MEDIA_BASE}/w_en_yes.mp3?${V}`, audioCn: `${MEDIA_BASE}/w_cn_yes.mp3?${V}` },
        { en: 'it', cn: '它/这', audioEn: `${MEDIA_BASE}/w_en_it.mp3?${V}`, audioCn: `${MEDIA_BASE}/w_cn_it.mp3?${V}` },
        { en: 'my', cn: '我的', audioEn: `${MEDIA_BASE}/w_en_my.mp3?${V}`, audioCn: `${MEDIA_BASE}/w_cn_my.mp3?${V}` },
        { en: 'Yes, it is.', cn: '是的，它是。', audioEn: `${MEDIA_BASE}/s_en_yes_it_is.mp3?${V}`, audioCn: `${MEDIA_BASE}/s_cn_yes_it_is.mp3?${V}` },
        { en: 'Yes, it is my ax.', cn: '是的，这是我的斧子。', audioEn: `${MEDIA_BASE}/s_en_yes_it_is_my_ax.mp3?${V}`, audioCn: `${MEDIA_BASE}/s_cn_yes_it_is_my_ax.mp3?${V}` },
      ],
    },

    // Step 6: Learn the Story (1)
    {
      label: 'Learn the Story (1)',
      layout: 'video-top-lines-bottom',
      videos: [{ src: `${MEDIA_BASE}/video_story_alligator.mp4?${V}`, poster: `${MEDIA_BASE}/image17.png?${V}` }],
      lines: [
        { en: 'Alligator has an ax.', cn: '鳄鱼有一把斧子。', audioEn: `${MEDIA_BASE}/story1_en_1.mp3?${V}`, audioCn: `${MEDIA_BASE}/story1_cn_1.mp3?${V}` },
        { en: 'Is this your ax?', cn: '这是你的斧子吗？', audioEn: `${MEDIA_BASE}/story1_en_2.mp3?${V}`, audioCn: `${MEDIA_BASE}/story1_cn_2.mp3?${V}` },
        { en: 'Yes, it is my ax.', cn: '是的，这是我的斧子。', audioEn: `${MEDIA_BASE}/story1_en_3.mp3?${V}`, audioCn: `${MEDIA_BASE}/story1_cn_3.mp3?${V}` },
      ],
    },

    // Step 7: Learn the Story (2)
    {
      label: 'Learn the Story (2)',
      layout: 'video-top-lines-bottom',
      videos: [{ src: `${MEDIA_BASE}/video_story_ant.mp4?${V}`, poster: `${MEDIA_BASE}/image18.png?${V}` }],
      lines: [
        { en: 'Ant has an apple.', cn: '蚂蚁有一个苹果。', audioEn: `${MEDIA_BASE}/story2_en_1.mp3?${V}`, audioCn: `${MEDIA_BASE}/story2_cn_1.mp3?${V}` },
        { en: 'Is this your apple?', cn: '这是你的苹果吗？', audioEn: `${MEDIA_BASE}/story2_en_2.mp3?${V}`, audioCn: `${MEDIA_BASE}/story2_cn_2.mp3?${V}` },
        { en: 'Yes, it is my apple.', cn: '是的，这是我的苹果。', audioEn: `${MEDIA_BASE}/story2_en_3.mp3?${V}`, audioCn: `${MEDIA_BASE}/story2_cn_3.mp3?${V}` },
      ],
    },

    // Step 8: The Sound of Aa — dual-videos
    {
      label: 'The Sound of A',
      layout: 'dual-videos',
      videos: [
        { src: `${MEDIA_BASE}/video_sound_aa_1.mp4?${V}`, poster: `${MEDIA_BASE}/image15.png?${V}` },
        { src: `${MEDIA_BASE}/video_sound_aa_2.mp4?${V}`, poster: `${MEDIA_BASE}/image16.png?${V}` },
      ],
      splitAt: 2,
      lines: [
        { en: 'sound', cn: '声音', audioEn: `${MEDIA_BASE}/sound_word_en.mp3?${V}`, audioCn: `${MEDIA_BASE}/sound_word_cn.mp3?${V}` },
        { en: 'the sound of ...', cn: '...的声音', audioEn: `${MEDIA_BASE}/sound_phrase_en.mp3?${V}`, audioCn: `${MEDIA_BASE}/sound_phrase_cn.mp3?${V}` },
        { en: 'The Sound of A', cn: 'A 的声音', audioEn: `${MEDIA_BASE}/sound_title_en.mp3?${V}`, audioCn: `${MEDIA_BASE}/sound_title_cn.mp3?${V}` },
      ],
    },
  ],

  // 封面背景图
  coverBg: `${MEDIA_BASE}/image1.jpeg`,

  // 视频封面图
  coverPoster: `${MEDIA_BASE}/cover.jpg`,
};

export default letterData;
